module.exports = __webpack_public_path__ + "img/EA155&156_1-1.d81b135f.jpg";